import gql from 'graphql-tag';

export default gql`
    query GetJobLogsDetails($jobId: Int, $tzinfo: String) {
        getJobLogsDetails(jobId: $jobId, tzinfo: $tzinfo) {
            id
            jobLogIssueId
            jobLogIssue
            jobLogTypeId
            jobLogType
            jobId
            status
            startDate
            endDate
            estimatedDowntime
            jobStageId
            stage
            loadId
            notes
            locationLofa
            lofa
            amount
            rootCauseId
            rootCause
            correctiveAction
            dateCreated
            dateUpdated
            createdBy
            updatedBy
            wellName
            overallStage
            totalSandPumped
            allNotes
            fullNotes {
                id
                notes
                dateCreated
                createdBy
            }
        }
    }
`;
